
(function(){
  "use strict";

  var REDUCED  = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var TOUCH    = !!(window.matchMedia && window.matchMedia('(hover:none)').matches);
  var gsap     = window.gsap;
  var hasGSAP  = typeof gsap !== 'undefined';
  var hasST    = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
  var hasSplit = hasGSAP && typeof window.SplitText !== 'undefined';
  var hasLenis = typeof window.Lenis !== 'undefined';

  var $  = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  if(hasST)    gsap.registerPlugin(window.ScrollTrigger);
  if(hasSplit) gsap.registerPlugin(window.SplitText);

  /* ==========================================================
     PRELOADER (vanilla rAF, always resolves, under 2.5s)
     ========================================================== */
  var pre = $('#pre'), preNum = $('#preNum'), preFill = $('#preFill'),
      preCap = $('#preCap'), preLot = $('#preLot');
  var caps = ['PULLING SHELF INVENTORY','READING LOT CARDS','CHECKING COLD CHAIN','OPENING THE COUNTER'];
  var preDone = false;

  function paintPre(p){
    var pi = Math.round(p);
    if(preNum)  preNum.textContent = String(pi).length < 3 ? ('00'+pi).slice(-3) : String(pi);
    if(preFill) preFill.style.transform = 'scaleX(' + (p/100) + ')';
    if(preLot)  preLot.textContent = 'LOT FL, ' + ('0000' + Math.min(287, Math.floor(p/100*287))).slice(-4);
    if(preCap)  preCap.textContent = caps[Math.min(caps.length-1, Math.floor(p/26))];
  }

  function runPre(){
    var p = 0;
    (function step(){
      p = Math.min(100, p + (100-p)*0.035 + 0.45);
      paintPre(p);
      if(p < 99.4) requestAnimationFrame(step);
      else { paintPre(100); setTimeout(endPre, 260); }
    })();
  }

  function endPre(){
    if(preDone) return; preDone = true;
    if(pre){
      if(hasGSAP && !REDUCED){
        gsap.to(pre,{yPercent:-100,duration:.72,ease:'power4.inOut',onComplete:function(){
          pre.style.display='none';
          if(hasST) window.ScrollTrigger.refresh();
        }});
      } else {
        pre.style.display='none';
      }
    }
    startIntro();
  }

  if(pre){
    setTimeout(function(){ if(!preDone) endPre(); }, 3200);
    if(REDUCED){ paintPre(100); setTimeout(endPre, 220); } else { runPre(); }
  } else {
    preDone = true;
    setTimeout(startIntro, 0);
  }

  /* ==========================================================
     CROSSHAIR CURSOR
     ========================================================== */
  (function(){
    if(REDUCED || TOUCH) return;
    var xh = $('#xh'), v = $('#xh-v'), h = $('#xh-h'), r = $('#xh-r');
    if(!xh) return;
    document.body.classList.add('xh-on');
    var mx = window.innerWidth/2, my = window.innerHeight/2, rx = mx, ry = my, shown = false;
    window.addEventListener('mousemove', function(e){
      mx = e.clientX; my = e.clientY;
      if(!shown){ xh.style.opacity = '1'; shown = true; }
      if(v) v.style.transform = 'translateX(' + mx + 'px)';
      if(h) h.style.transform = 'translateY(' + my + 'px)';
    }, {passive:true});
    (function raf(){
      rx += (mx-rx)*0.22; ry += (my-ry)*0.22;
      if(r) r.style.transform = 'translate(' + (rx-13) + 'px,' + (ry-13) + 'px)';
      requestAnimationFrame(raf);
    })();
    document.addEventListener('mouseover', function(e){
      var hot = e.target && e.target.closest && e.target.closest('a,button,input,[data-cursor],[tabindex]');
      xh.classList.toggle('hot', !!hot);
    });
    window.addEventListener('mouseout', function(e){
      if(e.relatedTarget === null){ xh.style.opacity = '0'; shown = false; }
    });
  })();

  /* ==========================================================
     NAV SHRINK + SCROLL PROGRESS
     ========================================================== */
  (function(){
    var nav = $('#nav'), prog = $('#progress');
    function upd(){
      var y = window.scrollY || window.pageYOffset;
      if(nav) nav.classList.toggle('shrunk', y > 60);
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if(prog) prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y/max) : 0) + ')';
    }
    window.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd);
    upd();
  })();

  /* ==========================================================
     ANNOUNCEMENT TICKER
     ========================================================== */
  (function(){
    var rot = $('#annRot'); if(!rot) return;
    var slides = $$('.ann-slide', rot);
    if(slides.length < 2) return;
    if(!hasGSAP || REDUCED){
      slides.forEach(function(s,i){ s.style.opacity = i === 0 ? '1' : '0'; });
      return;
    }
    gsap.set(slides, {yPercent:110, opacity:0});
    gsap.set(slides[0], {yPercent:0, opacity:1});
    var i = 0;
    setInterval(function(){
      var cur = slides[i], nxt = slides[(i+1) % slides.length];
      gsap.to(cur, {yPercent:-110, opacity:0, duration:.55, ease:'power3.inOut'});
      gsap.fromTo(nxt, {yPercent:110, opacity:0}, {yPercent:0, opacity:1, duration:.55, ease:'power3.out'});
      i = (i+1) % slides.length;
    }, 4200);
  })();

  /* ==========================================================
     HERO CANVAS · abstract machining spectacle
     concentric machined rings, an orange cutting arc,
     swarf particles and a traversing tool sled.
     Readouts in the hero panel are bound to these values.
     ========================================================== */
  (function(){
    var cv = $('#heroCanvas'); if(!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d'); if(!ctx) return;

    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, raf = 0, live = false, t = 0, frame = 0;
    var parts = [];
    var sim = { rpm: 2400, feed: 180, pass: 1, dia: 22.0, ang: 0, sled: 0 };

    var out = {
      rpm:  $('#rpmVal'), feed: $('#feedVal'),
      pass: $('#passVal'), dia: $('#diaVal'), run: $('#hpRun')
    };

    function size(){
      var r = cv.getBoundingClientRect();
      cv.width  = Math.max(1, Math.round(r.width  * DPR));
      cv.height = Math.max(1, Math.round(r.height * DPR));
      W = cv.width; H = cv.height;
    }

    function spawn(cx, cy, a, R){
      if(parts.length > 150) return;
      for(var i=0;i<2;i++){
        parts.push({
          x: cx + Math.cos(a)*R, y: cy + Math.sin(a)*R,
          vx: Math.cos(a + 1.1)*(1.6+Math.random()*2.4)*DPR,
          vy: Math.sin(a + 1.1)*(1.6+Math.random()*2.4)*DPR - 0.4*DPR,
          l: 1
        });
      }
    }

    function draw(){
      ctx.clearRect(0,0,W,H);
      var wide = W/H > 1.15;
      var cx = W * (wide ? 0.70 : 0.5);
      var cy = H * (wide ? 0.52 : 0.42);
      var R  = Math.min(W, H) * (wide ? 0.30 : 0.26);

      // blueprint field
      ctx.save();
      ctx.strokeStyle = 'rgba(139,147,156,.09)';
      ctx.lineWidth = 1*DPR;
      var g = 58*DPR, off = (t*6) % g;
      for(var x = -off; x < W; x += g){ ctx.beginPath(); ctx.moveTo(x,0); ctx.lineTo(x,H); ctx.stroke(); }
      for(var y = -off; y < H; y += g){ ctx.beginPath(); ctx.moveTo(0,y); ctx.lineTo(W,y); ctx.stroke(); }
      ctx.restore();

      // machined rings
      var rings = 13;
      for(var i=0;i<rings;i++){
        var rr = R * (1 - i*0.062) * (1 - (sim.pass-1)*0.006);
        if(rr <= 2) continue;
        ctx.beginPath();
        ctx.arc(cx, cy, rr, 0, Math.PI*2);
        ctx.strokeStyle = i % 4 === 0 ? 'rgba(196,204,212,.34)' : 'rgba(139,147,156,.16)';
        ctx.lineWidth = (i % 4 === 0 ? 1.3 : 1) * DPR;
        ctx.stroke();
      }

      // radial spokes turning with the spindle
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(sim.ang);
      ctx.strokeStyle = 'rgba(139,147,156,.2)';
      ctx.lineWidth = 1*DPR;
      for(var s=0;s<24;s++){
        var a = s/24 * Math.PI*2;
        ctx.beginPath();
        ctx.moveTo(Math.cos(a)*R*0.24, Math.sin(a)*R*0.24);
        ctx.lineTo(Math.cos(a)*R*0.98, Math.sin(a)*R*0.98);
        ctx.stroke();
      }
      ctx.restore();

      // hub
      ctx.beginPath();
      ctx.arc(cx, cy, R*0.13, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(42,47,54,.9)';
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,90,0,.7)';
      ctx.lineWidth = 1.4*DPR;
      ctx.stroke();

      // cutting arc
      var ca = sim.ang * 1.0;
      ctx.beginPath();
      ctx.arc(cx, cy, R*0.99, ca, ca + 1.05);
      ctx.strokeStyle = '#ff5a00';
      ctx.lineWidth = 2.6*DPR;
      ctx.stroke();

      ctx.save();
      ctx.globalAlpha = .28;
      ctx.beginPath();
      ctx.arc(cx, cy, R*0.99, ca - 1.6, ca);
      ctx.strokeStyle = '#ff5a00';
      ctx.lineWidth = 6*DPR;
      ctx.stroke();
      ctx.restore();

      // contact point + swarf
      var px = cx + Math.cos(ca)*R*0.99, py = cy + Math.sin(ca)*R*0.99;
      ctx.beginPath();
      ctx.arc(px, py, 3.4*DPR, 0, Math.PI*2);
      ctx.fillStyle = '#ffb47a';
      ctx.fill();
      if(live) spawn(cx, cy, ca, R*0.99);

      for(var p=parts.length-1;p>=0;p--){
        var q = parts[p];
        q.x += q.vx; q.y += q.vy; q.vy += 0.09*DPR; q.l -= 0.022;
        if(q.l <= 0){ parts.splice(p,1); continue; }
        ctx.globalAlpha = Math.max(0, q.l);
        ctx.fillStyle = q.l > .6 ? '#ffb47a' : '#ff5a00';
        ctx.fillRect(q.x, q.y, 2.2*DPR, 2.2*DPR);
      }
      ctx.globalAlpha = 1;

      // tool sled travelling under the stock
      var sledX = cx - R*1.15 + (sim.sled * R*2.3);
      var sledY = cy + R*1.22;
      ctx.strokeStyle = 'rgba(139,147,156,.28)';
      ctx.lineWidth = 1*DPR;
      ctx.beginPath(); ctx.moveTo(cx - R*1.3, sledY); ctx.lineTo(cx + R*1.3, sledY); ctx.stroke();
      ctx.fillStyle = '#ff5a00';
      ctx.beginPath();
      ctx.moveTo(sledX, sledY - 13*DPR);
      ctx.lineTo(sledX + 9*DPR, sledY + 6*DPR);
      ctx.lineTo(sledX - 9*DPR, sledY + 6*DPR);
      ctx.closePath(); ctx.fill();

      // dimension line across the stock
      ctx.strokeStyle = 'rgba(255,90,0,.55)';
      ctx.lineWidth = 1*DPR;
      var dy = cy - R*1.28;
      ctx.beginPath();
      ctx.moveTo(cx - R, dy); ctx.lineTo(cx + R, dy);
      ctx.moveTo(cx - R, dy - 5*DPR); ctx.lineTo(cx - R, dy + 5*DPR);
      ctx.moveTo(cx + R, dy - 5*DPR); ctx.lineTo(cx + R, dy + 5*DPR);
      ctx.stroke();
    }

    function readouts(){
      if(out.rpm)  out.rpm.innerHTML  = Math.round(sim.rpm) + '<u>rpm</u>';
      if(out.feed) out.feed.innerHTML = Math.round(sim.feed) + '<u>mm/min</u>';
      if(out.pass) out.pass.innerHTML = ('0'+sim.pass).slice(-2) + '<u>/12</u>';
      if(out.dia)  out.dia.innerHTML  = sim.dia.toFixed(1) + '<u>mm</u>';
      if(out.run)  out.run.textContent = 'RUN ' + ('0000' + (1180 + Math.floor(t/6))).slice(-4);
    }

    function tick(){
      t += 1/60; frame++;
      sim.ang  += 0.028 + Math.sin(t*0.6)*0.004;
      sim.sled  = (Math.sin(t*0.42) + 1) / 2;
      sim.rpm   = 2400 + Math.sin(t*1.7)*180 + Math.sin(t*0.31)*90;
      sim.feed  = 180 + Math.sin(t*0.9)*34;
      sim.pass  = 1 + (Math.floor(t/3.2) % 12);
      sim.dia   = 22.0 - (sim.pass-1)*0.35 - (Math.sin(t*0.42)+1)*0.06;
      draw();
      if(frame % 6 === 0) readouts();
      raf = requestAnimationFrame(tick);
    }

    function start(){ if(live) return; live = true; if(!raf) raf = requestAnimationFrame(tick); }
    function stop(){ live = false; if(raf){ cancelAnimationFrame(raf); raf = 0; } }

    size();
    var rt;
    window.addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(function(){ size(); if(!live) draw(); }, 160);
    });

    if(REDUCED){ draw(); readouts(); return; }

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(e){ if(e.isIntersecting) start(); else stop(); });
      }, {threshold:0.02}).observe(cv);
    } else { start(); }
    draw(); readouts();
  })();

  /* ==========================================================
     SHELF FILTER
     ========================================================== */
  (function(){
    var grid = $('#productGrid'); if(!grid) return;
    var chips = $$('#chips .chip'),
        cards = $$('.product-card', grid),
        shown = $('#fShown'), total = $('#fTotal');
    if(total) total.textContent = ('0'+cards.length).slice(-2);

    function apply(f){
      var count = 0, incoming = [];
      cards.forEach(function(c){
        var match = (f === 'all' || c.getAttribute('data-cat') === f);
        if(match){
          count++;
          if(c.style.display === 'none'){ c.style.display = ''; incoming.push(c); }
        } else {
          c.style.display = 'none';
        }
      });
      if(shown) shown.textContent = ('0'+count).slice(-2);
      if(hasGSAP && !REDUCED){
        var visible = cards.filter(function(c){ return c.style.display !== 'none'; });
        gsap.fromTo(visible, {opacity:0, y:22}, {opacity:1, y:0, duration:.5, ease:'power3.out', stagger:.035, overwrite:true});
      }
      if(hasST) window.ScrollTrigger.refresh();
    }

    chips.forEach(function(ch){
      ch.addEventListener('click', function(){
        chips.forEach(function(o){ o.classList.remove('on'); });
        ch.classList.add('on');
        apply(ch.getAttribute('data-filter') || 'all');
      });
    });
  })();

  /* ==========================================================
     COLLECTION ROWS · fill wipe + floating preview
     ========================================================== */
  (function(){
    var list = $('#colList'), pv = $('#colPreview');
    if(!list) return;
    var rows = $$('.col-row', list);
    var arts = pv ? $$('.cp-art', pv) : [];
    var px = 0, py = 0, tx = 0, ty = 0, active = false;

    rows.forEach(function(row){
      var fill = row.querySelector('.cr-fill');
      function on(){
        if(hasGSAP && !REDUCED && fill) gsap.to(fill, {scaleY:1, duration:.42, ease:'power3.out'});
        else if(fill) fill.style.transform = 'scaleY(1)';
        if(pv && !TOUCH && !REDUCED){
          var idx = row.getAttribute('data-col');
          arts.forEach(function(a){ a.classList.toggle('on', a.getAttribute('data-cp') === idx); });
          active = true;
          if(hasGSAP) gsap.to(pv, {opacity:1, duration:.25});
          else pv.style.opacity = '1';
        }
      }
      function off(){
        if(hasGSAP && !REDUCED && fill) gsap.to(fill, {scaleY:0, duration:.34, ease:'power2.in'});
        else if(fill) fill.style.transform = 'scaleY(0)';
        if(pv && !TOUCH){
          active = false;
          if(hasGSAP && !REDUCED) gsap.to(pv, {opacity:0, duration:.2});
          else pv.style.opacity = '0';
        }
      }
      row.addEventListener('mouseenter', on);
      row.addEventListener('mouseleave', off);
      row.addEventListener('focus', on);
      row.addEventListener('blur', off);
    });

    if(pv && !TOUCH && !REDUCED){
      window.addEventListener('mousemove', function(e){ tx = e.clientX + 26; ty = e.clientY - 86; }, {passive:true});
      (function loop(){
        px += (tx-px)*0.14; py += (ty-py)*0.14;
        if(active) pv.style.transform = 'translate(' + px + 'px,' + py + 'px)';
        requestAnimationFrame(loop);
      })();
    }
  })();

  /* ==========================================================
     FAQ ACCORDION
     ========================================================== */
  (function(){
    $$('#faqList .faq-item').forEach(function(item){
      var q = item.querySelector('.faq-q'),
          a = item.querySelector('.faq-a'),
          inner = item.querySelector('.inner');
      if(!q || !a || !inner) return;
      q.addEventListener('click', function(){
        var open = item.classList.contains('open');
        $$('#faqList .faq-item.open').forEach(function(o){
          if(o === item) return;
          o.classList.remove('open');
          var oa = o.querySelector('.faq-a');
          if(hasGSAP && !REDUCED) gsap.to(oa, {height:0, duration:.4, ease:'power2.inOut'});
          else oa.style.height = '0px';
        });
        if(open){
          item.classList.remove('open');
          if(hasGSAP && !REDUCED) gsap.to(a, {height:0, duration:.4, ease:'power2.inOut'});
          else a.style.height = '0px';
        } else {
          item.classList.add('open');
          var h = inner.offsetHeight;
          if(hasGSAP && !REDUCED) gsap.fromTo(a, {height:0}, {height:h, duration:.5, ease:'power3.out', onComplete:function(){ a.style.height='auto'; }});
          else a.style.height = 'auto';
        }
      });
    });
  })();

  /* ==========================================================
     NEWSLETTER MOCK
     ========================================================== */
  (function(){
    var form = $('#suForm'), input = $('#suEmail'), msg = $('#suMsg');
    if(!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var v = input ? input.value.trim() : '';
      if(!msg) return;
      if(v.indexOf('@') < 1 || v.length < 5){
        msg.textContent = 'ENTER A VALID LAB EMAIL';
      } else {
        msg.textContent = 'ON THE LIST · FRONT END MOCK, NOTHING WAS SENT';
        if(input) input.value = '';
      }
      if(hasGSAP && !REDUCED) gsap.fromTo(msg, {opacity:0, y:6}, {opacity:1, y:0, duration:.4, ease:'power2.out'});
    });
  })();

  /* ==========================================================
     EASTER EGG · type "foundry"
     ========================================================== */
  (function(){
    var buf = '', target = 'foundry', egg = $('#egg');
    window.addEventListener('keydown', function(e){
      if(!e.key || e.key.length !== 1) return;
      buf = (buf + e.key.toLowerCase()).slice(-target.length);
      if(buf !== target || !egg) return;
      var st = egg.querySelector('.st');
      if(hasGSAP && !REDUCED){
        gsap.killTweensOf(st);
        gsap.set(egg, {opacity:1});
        gsap.fromTo(st, {scale:.3, rotate:-30, opacity:0}, {scale:1, rotate:-8, opacity:1, duration:.5, ease:'back.out(2)'});
        gsap.to(egg, {opacity:0, duration:.5, delay:1.3});
      } else {
        egg.style.opacity = '1';
        setTimeout(function(){ egg.style.opacity = '0'; }, 1300);
      }
    });
  })();

  /* ==========================================================
     MARQUEES
     ========================================================== */
  (function(){
    if(REDUCED || !hasGSAP) return;
    $$('[data-marquee]').forEach(function(track){
      track.innerHTML = track.innerHTML + track.innerHTML;
      var w = track.scrollWidth / 2;
      if(!w) return;
      var dur = parseFloat(track.getAttribute('data-speed') || '28');
      gsap.to(track, {x:-w, duration:dur, ease:'none', repeat:-1,
        modifiers:{ x:function(x){ return (parseFloat(x) % w) + 'px'; } }});
    });
  })();

  /* ==========================================================
     FINAL STATES (no GSAP / reduced motion)
     ========================================================== */
  function setFinalStates(){
    $$('[data-count]').forEach(function(el){
      var to  = parseFloat(el.getAttribute('data-count')),
          dec = parseInt(el.getAttribute('data-dec') || '0', 10),
          suf = el.getAttribute('data-suffix') || '';
      var val = dec > 0 ? to.toFixed(dec) : Math.round(to).toLocaleString('en-US');
      el.innerHTML = val + (suf ? '<span class="u">' + suf + '</span>' : '');
    });
  }

  /* ==========================================================
     HERO INTRO
     ========================================================== */
  function startIntro(){
    if(!hasGSAP || REDUCED){ setFinalStates(); return; }

    var tl = gsap.timeline({defaults:{ease:'power4.out'}});
    var chars = $$('#heroWord [data-c]');
    gsap.set(chars, {yPercent:120});
    tl.to(chars, {yPercent:0, duration:1.0, stagger:.085}, 0.05);

    var bar = $('#dimline .bar'), val = $('#dimline .val');
    if(bar) gsap.set(bar, {scaleX:0});
    if(val) gsap.set(val, {opacity:0});
    if(bar) tl.to(bar, {scaleX:1, duration:.9, ease:'power3.inOut'}, 0.45);
    if(val) tl.to(val, {opacity:1, duration:.4}, 0.9);

    gsap.set(['.hero-copy .tag', '.hero-sub', '.hero-cta'], {opacity:0, y:22});
    tl.to('.hero-copy .tag', {opacity:1, y:0, duration:.6}, 0.15)
      .to('.hero-sub', {opacity:1, y:0, duration:.7}, 0.7)
      .to('.hero-cta', {opacity:1, y:0, duration:.7}, 0.85);

    gsap.set('#heroRail .hs', {opacity:0, y:18});
    tl.to('#heroRail .hs', {opacity:1, y:0, duration:.55, stagger:.08}, 0.95);

    var panel = $('#heroPanel');
    if(panel){
      gsap.set(panel, {opacity:0, y:34});
      tl.to(panel, {opacity:1, y:0, duration:.9}, 0.5);
    }
    gsap.set('.hp-cell', {opacity:0});
    tl.to('.hp-cell', {opacity:1, duration:.4, stagger:.07}, 0.85);

    var scan = $('#heroScan');
    if(scan){
      gsap.fromTo(scan, {yPercent:-120}, {yPercent:520, duration:5.6, ease:'none', repeat:-1, delay:1});
    }

    buildScroll();
  }

  /* ==========================================================
     SCROLL CHOREOGRAPHY
     ========================================================== */
  function buildScroll(){
    if(!hasGSAP || !hasST){ setFinalStates(); return; }
    var ScrollTrigger = window.ScrollTrigger;

    /* headline line-mask rises */
    $$('.reveal-h').forEach(function(el){
      if(hasSplit){
        try{
          var split = new window.SplitText(el, {type:'lines', linesClass:'sl-line'});
          var inner = split.lines.map(function(l){
            l.style.overflow = 'hidden'; l.style.display = 'block';
            var w = document.createElement('span');
            w.style.display = 'block';
            while(l.firstChild) w.appendChild(l.firstChild);
            l.appendChild(w);
            return w;
          });
          gsap.set(inner, {yPercent:115});
          gsap.to(inner, {yPercent:0, duration:.9, ease:'power4.out', stagger:.08,
            scrollTrigger:{trigger:el, start:'top 86%'}});
          return;
        }catch(err){}
      }
      gsap.fromTo(el, {opacity:0, y:32}, {opacity:1, y:0, duration:.9, ease:'power3.out',
        scrollTrigger:{trigger:el, start:'top 88%'}});
    });

    /* selling points */
    gsap.fromTo('[data-pt]', {opacity:0, y:34}, {opacity:1, y:0, duration:.75, ease:'power3.out', stagger:.11,
      scrollTrigger:{trigger:'#points', start:'top 86%'}});
    $$('[data-pt] .pt-ico').forEach(function(ico){
      gsap.fromTo(ico, {scale:.6, opacity:0}, {scale:1, opacity:1, duration:.6, ease:'back.out(2)',
        scrollTrigger:{trigger:ico, start:'top 92%'}});
    });

    /* product cards */
    var cards = $$('#productGrid .product-card');
    gsap.fromTo(cards, {opacity:0, y:46}, {opacity:1, y:0, duration:.8, ease:'power3.out', stagger:.06,
      scrollTrigger:{trigger:'#productGrid', start:'top 84%'}});
    $$('#productGrid .pc-badge').forEach(function(b){
      gsap.fromTo(b, {scale:.4, opacity:0}, {scale:1, opacity:1, duration:.5, ease:'back.out(2.6)',
        scrollTrigger:{trigger:b, start:'top 92%'}});
    });
    gsap.fromTo('#chips .chip', {opacity:0, y:16}, {opacity:1, y:0, duration:.5, ease:'power2.out', stagger:.05,
      scrollTrigger:{trigger:'#chips', start:'top 92%'}});
    gsap.fromTo('.shop-note', {opacity:0, y:26}, {opacity:1, y:0, duration:.7, ease:'power3.out',
      scrollTrigger:{trigger:'.shop-note', start:'top 92%'}});

    /* reviews + stats + press */
    gsap.fromTo('[data-rev]', {opacity:0, y:40}, {opacity:1, y:0, duration:.8, ease:'power3.out', stagger:.1,
      scrollTrigger:{trigger:'.rev-grid', start:'top 85%'}});
    $$('[data-rev] .stars svg').forEach(function(s, i){
      gsap.fromTo(s, {scale:0, opacity:0}, {scale:1, opacity:1, duration:.4, ease:'back.out(3)', delay:(i%5)*0.05,
        scrollTrigger:{trigger:s.closest('[data-rev]'), start:'top 88%'}});
    });
    gsap.fromTo('.stat', {opacity:0, y:28}, {opacity:1, y:0, duration:.7, ease:'power3.out', stagger:.08,
      scrollTrigger:{trigger:'#statsStrip', start:'top 88%'}});

    /* count ups */
    $$('[data-count]').forEach(function(el){
      var to  = parseFloat(el.getAttribute('data-count')),
          dec = parseInt(el.getAttribute('data-dec') || '0', 10),
          suf = el.getAttribute('data-suffix') || '',
          obj = {v:0};
      ScrollTrigger.create({trigger:el, start:'top 90%', once:true, onEnter:function(){
        gsap.to(obj, {v:to, duration:1.6, ease:'power2.out', onUpdate:function(){
          var val = dec > 0 ? obj.v.toFixed(dec) : Math.round(obj.v).toLocaleString('en-US');
          el.innerHTML = val + (suf ? '<span class="u">' + suf + '</span>' : '');
        }});
      }});
    });

    /* collection rows */
    gsap.fromTo('.col-row', {opacity:0, y:34}, {opacity:1, y:0, duration:.7, ease:'power3.out', stagger:.07,
      scrollTrigger:{trigger:'#colList', start:'top 86%'}});

    /* comparison rows */
    gsap.fromTo('#cmpBox tbody tr', {opacity:0, x:-18}, {opacity:1, x:0, duration:.55, ease:'power2.out', stagger:.06,
      scrollTrigger:{trigger:'#cmpBox', start:'top 84%'}});

    /* faq rows */
    gsap.fromTo('#faqList .faq-item', {opacity:0, y:22}, {opacity:1, y:0, duration:.6, ease:'power3.out', stagger:.06,
      scrollTrigger:{trigger:'#faqList', start:'top 86%'}});

    /* newsletter panel */
    gsap.fromTo('#suForm', {opacity:0, y:34}, {opacity:1, y:0, duration:.8, ease:'power3.out',
      scrollTrigger:{trigger:'#suForm', start:'top 88%'}});
    gsap.fromTo('.disclaim', {opacity:0, y:24}, {opacity:1, y:0, duration:.7, ease:'power3.out',
      scrollTrigger:{trigger:'.disclaim', start:'top 92%'}});

    /* footer columns */
    gsap.fromTo('.foot-col, .foot-brand', {opacity:0, y:26}, {opacity:1, y:0, duration:.7, ease:'power3.out', stagger:.07,
      scrollTrigger:{trigger:'.foot-grid', start:'top 90%'}});

    /* ---------- STORY SET PIECE · engraved lot plate ---------- */
    (function(){
      var border = $('#plBorder'), graver = $('#plGraver'), stamp = $('#plStamp'),
          rows = $$('#plRows .pl-row'), title = $('#plHead-title'), spark = $('#plSpark');
      if(!border || !graver) return;

      var len = 2100;
      try{ len = border.getTotalLength(); }catch(err){}
      border.style.strokeDasharray = len;
      border.style.strokeDashoffset = len;

      var stops = [164, 212, 260, 308, 356, 404];

      function buildTl(scrubbed){
        var tl = gsap.timeline(scrubbed ? {
          scrollTrigger:{trigger:'#story', start:'top top', end:'+=2400', scrub:0.7, pin:'#storyPin', anticipatePin:1}
        } : {
          scrollTrigger:{trigger:'#story', start:'top 72%'}
        });

        gsap.set(graver, {opacity:0, x:300, y:150});
        gsap.set(stamp, {scale:0, opacity:0, transformOrigin:'50% 50%'});
        if(title) gsap.set(title, {opacity:0});
        rows.forEach(function(r){
          gsap.set(r.querySelectorAll('text'), {opacity:0});
          var line = r.querySelector('line');
          if(line) gsap.set(line, {opacity:0, scaleX:0, transformOrigin:'0% 50%'});
        });

        tl.to(border, {strokeDashoffset:0, duration:1.6, ease:'none'}, 0)
          .to(graver, {opacity:1, duration:.3}, 0.35)
          .to(title, {opacity:1, duration:.5}, 0.6);

        rows.forEach(function(r, i){
          var at = 1.1 + i*0.62;
          var texts = r.querySelectorAll('text');
          var line = r.querySelector('line');
          tl.to(graver, {x:120, y:stops[i]-14, duration:.36, ease:'power1.inOut'}, at)
            .to(texts[0], {opacity:1, duration:.22}, at+0.2)
            .to(graver, {x:520, duration:.42, ease:'power1.inOut'}, at+0.24)
            .to(texts[1], {opacity:1, duration:.26}, at+0.4);
          if(line) tl.to(line, {opacity:1, scaleX:1, duration:.3, ease:'power2.out'}, at+0.5);
        });

        var end = 1.1 + rows.length*0.62;
        tl.to(graver, {opacity:0, duration:.3}, end)
          .to(stamp, {scale:1, opacity:1, duration:.5, ease:'back.out(2.2)'}, end+0.1);

        return tl;
      }

      if(spark && !REDUCED){
        gsap.to(spark, {opacity:.25, scale:1.5, duration:.36, repeat:-1, yoyo:true, ease:'sine.inOut', transformOrigin:'50% 0%'});
      }

      var mm = gsap.matchMedia();
      mm.add('(min-width:901px)', function(){
        var tl = buildTl(true);
        return function(){
          if(tl.scrollTrigger) tl.scrollTrigger.kill(true);
          tl.kill();
        };
      });
      mm.add('(max-width:900px)', function(){
        var tl = buildTl(false);
        return function(){
          if(tl.scrollTrigger) tl.scrollTrigger.kill(true);
          tl.kill();
        };
      });
    })();

    ScrollTrigger.refresh();

    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(function(){ ScrollTrigger.refresh(); });
    }
  }

  /* ==========================================================
     LENIS + ANCHORS + MAGNETIC BUTTONS
     ========================================================== */
  var lenis = null;
  if(hasLenis && !REDUCED){
    lenis = new window.Lenis({duration:1.05, easing:function(t){ return Math.min(1, 1.001 - Math.pow(2, -10*t)); }, smoothWheel:true});
    if(hasST) lenis.on('scroll', window.ScrollTrigger.update);
    if(hasGSAP){
      gsap.ticker.add(function(time){ lenis.raf(time*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(time){ lenis.raf(time); requestAnimationFrame(raf); })();
    }
  }

  $$('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(!id || id.length < 2) return;
      var el = document.querySelector(id);
      if(!el) return;
      e.preventDefault();
      if(lenis) lenis.scrollTo(el, {offset:-72});
      else el.scrollIntoView({behavior: REDUCED ? 'auto' : 'smooth'});
    });
  });

  (function(){
    if(REDUCED || TOUCH || !hasGSAP) return;
    $$('.btn, .tool, .chip').forEach(function(b){
      b.addEventListener('mousemove', function(e){
        var r = b.getBoundingClientRect();
        gsap.to(b, {x:(e.clientX - r.left - r.width/2)*0.24, y:(e.clientY - r.top - r.height/2)*0.34, duration:.4, ease:'power2.out'});
      });
      b.addEventListener('mouseleave', function(){
        gsap.to(b, {x:0, y:0, duration:.5, ease:'elastic.out(1,.4)'});
      });
    });
  })();

  /* safety: if GSAP never arrived, paint the numbers */
  if(!hasGSAP) setFinalStates();

})();


(function(){
  var q=function(s,r){return (r||document).querySelector(s)}, qa=function(s,r){return Array.from((r||document).querySelectorAll(s));};
  function lock(on){document.documentElement.style.overflow=on?'hidden':'';}
  function initHeader(root){
    var toggle=q('[data-mobile-toggle]',root||document), drawer=q('[data-mobile-drawer]'), back=q('[data-drawer-backdrop]');
    if(toggle&&!toggle.dataset.ready){toggle.dataset.ready='1';var close=q('[data-drawer-close]',drawer);var shut=function(){drawer&&drawer.classList.remove('is-open');back&&back.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');lock(false);};toggle.addEventListener('click',function(){drawer.classList.add('is-open');back.classList.add('is-open');toggle.setAttribute('aria-expanded','true');lock(true);});close&&close.addEventListener('click',shut);back&&back.addEventListener('click',shut);drawer&&drawer.addEventListener('click',function(e){if(e.target.closest('a'))shut();});document.addEventListener('keydown',function(e){if(e.key==='Escape')shut();});}
    qa('[data-search-open]',root||document).forEach(function(btn){if(btn.dataset.ready)return;btn.dataset.ready='1';btn.addEventListener('click',function(){var m=q('[data-search-modal]');m.classList.add('is-open');lock(true);setTimeout(function(){q('input[type=search]',m)?.focus();},30);});});
  }
  function initSearch(){var m=q('[data-search-modal]');if(!m||m.dataset.ready)return;m.dataset.ready='1';var close=function(){m.classList.remove('is-open');lock(false);};qa('[data-search-close]',m).forEach(function(x){x.addEventListener('click',close)});m.addEventListener('click',function(e){if(e.target===m)close();});document.addEventListener('keydown',function(e){if(e.key==='Escape'&&m.classList.contains('is-open'))close();});}
  function initGallery(root){qa('[data-product-gallery]',root||document).forEach(function(g){qa('[data-media-thumb]',g).forEach(function(b){if(b.dataset.ready)return;b.dataset.ready='1';b.addEventListener('click',function(){var id=b.dataset.mediaThumb;qa('[data-media-panel]',g).forEach(function(p){p.hidden=p.dataset.mediaPanel!==id;p.classList.toggle('is-active',p.dataset.mediaPanel===id)});qa('[data-media-thumb]',g).forEach(function(x){x.classList.toggle('is-active',x===b)});});});});}
  function init(root){initHeader(root);initSearch();initGallery(root);}
  document.addEventListener('DOMContentLoaded',function(){init(document)});document.addEventListener('shopify:section:load',function(e){init(e.target);if(window.ScrollTrigger)requestAnimationFrame(function(){ScrollTrigger.refresh()})});
})();
/* Mobile-adaptive canvases v2: phones change layout boxes after first paint
   (font load, URL-bar collapse, aspect-ratio media flips) without always
   firing a window resize. Watch each canvas's own box and replay the theme's
   resize path ONLY when the box genuinely changed — several heroes rebuild
   and replay their intro on resize, so a synthetic ping on load or on the
   observer's first callback would visibly restart them. */
(function () {
  if (!('ResizeObserver' in window)) return;
  var last = new WeakMap();
  var t;
  function ping() { clearTimeout(t); t = setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120); }
  var ro = new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (en) {
      var r = en.target.getBoundingClientRect();
      var p = last.get(en.target);
      last.set(en.target, { w: r.width, h: r.height });
      if (p && (Math.abs(p.w - r.width) > 1 || Math.abs(p.h - r.height) > 1)) changed = true;
    });
    if (changed) ping();
  });
  function watch() { document.querySelectorAll('canvas').forEach(function (c) { ro.observe(c); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  window.addEventListener('orientationchange', function () { setTimeout(ping, 200); });
})();
